export var PowerType;
(function (PowerType) {
    PowerType["POWER_UP"] = "POWER_UP";
    PowerType["POWER_DOWN"] = "POWER_DOWN";
})(PowerType || (PowerType = {}));
